
import AnimatedSection from '../components/AnimatedSection';

const Experience = () => {
    // Experiencias ordenadas según el CV del usuario
    const experiences = [
        {
            date: "Remote | Feb 2022 – Jan 2025", title: "Senior Android Developer", company: "PayPal (Venmo)",
            star: [
                { text: "Developed and modularized key features in the Venmo app used by millions of users." },
                { text: "Reduced analytics platform costs by eliminating unnecessary events." },
                { text: "Implemented client-side marketing campaign integrations and feature flags (Optimizely, Braze)." },
                { text: "Collaborated with cross-functional teams on experimentation and continuous improvement." }
            ],
            techStack: ["Kotlin", "Java", "RxJava", "MVP", "Retrofit", "Room", "Feature Flags", "Amplitude", "Mparticle", "Braze", "Optimizely", "GitHub Actions", "Scrum"]
        },
        {
            date: "Remote | Oct 2021 – Jan 2022", title: "Senior Android Developer", company: "Limeade",
            star: [
                { text: "Improved app accessibility based on WCAG 2.1 standards." },
                { text: "Enhanced navigation using Jetpack Navigation component." },
                { text: "Implemented accessibility features across the app, meeting compliance goals." },
                { text: "Upgraded networking layer from OkHttp3 to Retrofit." }
            ],
            techStack: ["Kotlin", "Room", "LiveData", "MVVM", "Android Navigation", "Coroutines", "Kodein", "SCRUM"]
        },
        {
            date: "Remote | Jun 2021 – Oct 2021", title: "Senior Android Developer", company: "December Labs",
            star: [
                { text: "Migrated ChatOwl therapy app from Java to Kotlin and implemented new functionalities." },
                { text: "Released the app successfully on Google Play Store, achieving positive client adoption." },
                { text: "Maintained and enhanced an Android app using Mapbox SDK to provide real-time route tracing and navigation to the nearest gas stations." }
            ],
            techStack: ["Kotlin", "Java", "Room", "MVVM", "Retrofit", "LiveData", "Firebase", "Cognito", "Coroutines", "SCRUM", "Mapbox SDK"]
        },
        {
            date: "Remote | Feb 2025 – Present", title: "Senior Android Engineer", company: "DermicaPro",
            star: [
                { text: "Designed and developed a mobile app prototype that uses AI-powered image analysis to provide virtual diagnostics of facial conditions." },
                { text: "Built a modular Android app with Jetpack Compose for modern UI, Kotlin Coroutines for async processing, Hilt for dependency injection, and MVI architecture for state management." },
                { text: "Integrated ML Kit and external APIs to enable real-time skin analysis using smartphone cameras." },
                { text: "Implemented CI/CD pipelines with GitHub Actions, ensuring automated builds, tests, and secure deployments." },
                { text: "Optimized performance and accessibility, achieving a smoother UX and contributing to a 43% increase in client bookings." }
            ],
            techStack: ["Kotlin", "Jetpack Compose", "Hilt", "Coroutines", "CameraX", "ML Kit", "Retrofit", "Room", "Firebase", "GitHub Actions", "Clean Architecture", "MVVM", "MVI"]
        },
        {
            date: "Remote | Feb 2020 – Oct 2021", title: "Semi-Senior Scala Developer", company: "Jemstep Inc.",
            star: [
                { text: "Contributed to Advisor PRO, an investment advisor platform." },
                { text: "Supported customization and implementation team requirements." },
                { text: "Increased number of clients by 40% through product improvements." }
            ],
            techStack: ["Scala", "Backbone", "MongoDB", "AWS S3", "Splunk", "CI/CD with GoCD", "SplitIO"]
        },
        {
            date: "Trujillo, Peru | Oct 2018 – Jan 2020", title: "Semi-Senior Android Developer", company: "IBAO",
            star: [
                { text: "Led development of Android apps for agriculture, mining, and farming sectors." },
                { text: "Designed and implemented modern Android architectures (MVVM, MVP) to improve maintainability and scalability." },
                { text: "Built and integrated Room database, Retrofit networking layer, and LiveData/ViewModel for real-time data-driven decision-making." },
                { text: "Reduced reported security bugs by 98% through tokenization and improved app architecture." },
                { text: "Collaborated with cross-functional teams to enhance UI/UX and improve client satisfaction." }
            ],
            techStack: ["Kotlin", "Java", "Room", "Retrofit", "LiveData", "ViewModel", "Android Navigation", "Coroutines", "Firebase", "MVP", "MVVM", "Trello", "SQL Server", "SQLite"]
        },
        {
            date: "Remote | Jun 2017 – Aug 2018", title: "Software Developer", company: "GPS Jnisi",
            star: [
                { text: "Supported and extended a Java EE open-source tracking service (OpenGTS) for vehicle fleet management." },
                { text: "Built and maintained Android apps for taxi companies, integrating Google Maps API for real-time location tracking." },
                { text: "Implemented Firebase Cloud Messaging for live driver-passenger communication and notifications." },
                { text: "Developed custom modules to handle ride booking, payments, and fleet monitoring, improving operational efficiency for clients." },
                { text: "Delivered tailored instances of the platform for multiple Peruvian taxi companies, ensuring compliance with local transport regulations." }
            ],
            techStack: ["Java", "Kotlin", "PHP", "JavaScript", "SQLite", "MVP", "Firebase", "Google Maps API", "MySQL", "Android SDK"]
        },
        {
            date: "Remote | Feb 2025 – Present", title: "Senior Technical Interviewer (Android & Backend)", company: "Taller Technologies",
            star: [
                { text: "Conducted 100+ technical interviews for Android positions across various seniority levels." },
                { text: "Assessed candidates on Kotlin fundamentals, architectural patterns, UI/UX best practices, and testing strategies." },
                { text: "Helped refine the technical hiring rubric used for evaluating Android developers." }
            ],
            techStack: ["MVVM", "Clean Architecture", "Jetpack", "Unit Testing", "Dependency Injection", "CI/CD", "Git"]
        },
    ];

    return (
        <AnimatedSection id="experience" className="py-24">
            <h2 className="text-3xl font-bold text-white text-center mb-16">Career Journey</h2>
            <div className="relative max-w-3xl mx-auto pl-8">
                <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-slate-700"></div>
                {experiences.map((exp, index) => (
                    <div key={index} className="mb-12 relative timeline-item">
                        <div className="mb-4">
                            <p className="text-sm text-cyan-400">{exp.date}</p>
                            <h3 className="text-2xl font-bold text-white">{exp.company}</h3>
                            <p className="text-lg text-slate-300 font-medium">{exp.title}</p>
                        </div>
                        <ul className="list-disc list-inside space-y-2 text-slate-400">
                            {exp.star.map((item, i) => (
                                <li key={i}>{item.text}</li>
                            ))}
                        </ul>
                        <div className="mt-4">
                            <h4 className="text-sm font-semibold text-slate-300 mb-2">Tech Stack:</h4>
                            <div className="flex flex-wrap gap-2">
                                {exp.techStack.map(skill => (
                                    <span key={skill} className="bg-slate-700 text-slate-300 text-xs font-medium px-2 py-1 rounded-full">{skill}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </AnimatedSection>
    );
};

export default Experience;